module.exports = __webpack_public_path__ + "static/umeh-0b9eac0d061f4cd841af1b69ae963e36.jpg";